module.exports = __webpack_public_path__ + "assets/img/2b84c03d3758c3ab79f7e7be40e70cfd.png";